import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConnectionsComponent} from './connections.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {MaterialModule} from '../../material.module';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {FlexModule} from '@angular/flex-layout';
import { ConnectionsSearchComponent } from './connections-search/connections-search.component';
import {SearchModule} from '../../components/search/search.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ConnectionsStatusPipe} from '../../pipes/connection-status/connections-status.pipe';
import { ConnectionsDialogComponent } from './connections-dialog/connections-dialog.component';
import {DividerModule} from '../../components/separator/divider.module';
import { ConnectionEdgeStatusPipe } from './connection-edge-status.pipe';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {InfraModule} from 'ac-infra';


@NgModule({
    declarations: [
        ConnectionsComponent,
        ConnectionsSearchComponent,
        ConnectionsStatusPipe,
        ConnectionsDialogComponent,
        ConnectionEdgeStatusPipe
    ],
    imports: [
        CommonModule,
        LayoutModule,
        MaterialModule,
        DialogModule,
        FormsModule,
        FlexModule,
        SearchModule,
        ActionBarModule,
        DividerModule,
        ArmTableModule,
        InfraModule,
    ]
})
export class ConnectionsModule {
}
